/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
import React from 'react';
import { MapTo, Container } from '@adobe/aem-react-editable-components';
import '../../libs/aemComponents/Container';
import '../../libs/aemComponents/ExperienceFragment';
import {
  EditableHTLWrapper,
  StaticWrapper,
  CardLayered,
  NavigationContainerWrapper,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
  Footer,
} from '@marriott/mi-common-static-components';
import {
  ConnectContainerEditable,
  JoinBannerExperienceEditable,
  BonvoyApplicationAdEditable,
  LocalHeaderEditable,
  HeroBannerEditable,
  InternetBarEditable,
  AccuWeatherEditable,
  PropertyPortalContainerEditable,
  LocalServicesEditable,
  LetsConnectEditable,
  MMNComponentEditable,
  RTEEditable,
  PropertyPortalWrapperEditable,
} from '@marriott/mi-ppv5-components';
import {
  MerchandisingCarouselContainer,
  MerchandisingCardTile,
  MerchandisingTileSkinny,
  DCADecisionContainer,
  RiottMediaCard,
  MerchandisingSmallBanner,
} from '@marriott/mi-merch-components';
import { OfferCardCarousel } from '@marriott/mi-offers-components';
import { respGridUtil } from '@marriott/mi-headless-utils';
import { Text, Heading } from '@marriott/mi-ui-library';
import { FlyoutDrawer } from '@marriott/mi-book-components';
import { AccountContainerEditable, SignInEditable, SignInContentBlockEditable } from '@marriott/mi-account-components';
import { getAllowedComponentsForNonAuthorMode as getAllowedComponentsForNonAuthorModeUtil } from '@marriott/shared/mi-helper-utils';

export const AEM_REACT_MAPPING = {
  [`mi-aem-common-spa/components/common/staticwrapper`]: StaticWrapper,
  [`mi-aem-ppv5-spa/components/content/localheader`]: LocalHeaderEditable,
  [`mi-aem-ppv5-spa/components/content/hero-banner`]: HeroBannerEditable,
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  ['mi-aem-ppv5-spa/components/content/experiencefragment']: Container,
  [`mi-aem-ppv5-spa/components/common/staticwrapper`]: ConnectContainerEditable,
  [`mi-aem-ppv5-spa/components/content/internet-box`]: InternetBarEditable,
  [`mi-aem-ppv5-spa/components/content/accuWeather`]: AccuWeatherEditable,
  [`mi-aem-ppv5-spa/components/content/brandedcontainer`]: PropertyPortalContainerEditable,
  [`mi-aem-ppv5-spa/components/content/services-carousel`]: LocalServicesEditable,
  [`mi-aem-ppv5-spa/components/content/lets-connect-modal`]: LetsConnectEditable,
  [`mi-aem-ppv5-spa/components/content/ppv5-rte`]: RTEEditable,
  [`mi-aem-offers-spa/components/offers-cards`]: OfferCardCarousel,
  [`mi-aem-homepage-spa/components/content/universal-footer`]: Footer,
  [`mi-aem-common-spa/components/content/mmn-container`]: MMNComponentEditable,
  [`mi-aem-common-spa/components/content/bannerlayerer`]: JoinBannerExperienceEditable,
  [`mi-aem-common-spa/components/text`]: Text,
  [`mi-aem-common-spa/components/title`]: Heading,
  // [`mi-aem-common-spa/components/content/cardcarouselcontainer`]: CardCarouselContainer,
  [`mi-aem-common-spa/components/content/bannerlayered`]: JoinBannerExperienceEditable,
  [`mi-aem-common-spa/components/content/cardhorizontalmini`]: BonvoyApplicationAdEditable,
  [`mi-aem-common-spa/components/content/cardlayered`]: CardLayered,
  [`mi-aem-homepage-spa/components/content/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-homepage-spa/components/content/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-homepage-spa/components/content/primaryNavigation`]: NavigationWrapper,
  ['mi-aem-common-spa/components/content/mangopilot']: RiottMediaCard,
  ['mi-aem-common-spa/components/content/riottmediacard']: RiottMediaCard,
  [`mi-aem-common-spa/components/content/tilesquare`]: MerchandisingCardTile,
  [`mi-aem-common-spa/components/content/tileskinny`]: MerchandisingTileSkinny,
  [`mi-aem-common-spa/components/content/tilecarouselcontainer`]: MerchandisingCarouselContainer,
  [`mi-aem-common-spa/components/content/dcadecisioncontainer`]: DCADecisionContainer,
  [`mi-aem-common-spa/components/content/merchandisingsmallbanner`]: MerchandisingSmallBanner,
  [`mi-aem-common-spa/components/content/modal`]: PropertyPortalWrapperEditable,
  [`nt:unstructured`]: EditableHTLWrapper,
  [`mcom-book-spa/components/flyoutcontainer`]: FlyoutDrawer,
  [`mi-aem-account/components/content/accountcontainer`]: AccountContainerEditable,
  [`mi-aem-account/components/content/signin`]: SignInEditable,
  [`mi-aem-account/components/content/signincontentblock`]: SignInContentBlockEditable,
  [`mi-aem-account/components/content/datapagecomponent`]: Container,
};

export const AEM_REACT_TITLE_MAPPING = {
  'mi-aem-common-spa/components/common/staticwrapper': 'Static Wrapper',
  'mi-aem-ppv5-spa/components/content/localheader': 'Local Header',
  'mi-aem-ppv5-spa/components/content/hero-banner': 'Hero Banner',
  'mi-aem-common-spa/components/experiencefragment': 'Experience Fragment',
  'mi-aem-ppv5-spa/components/content/experiencefragment': 'PPV5 Experience Fragment',
  'mi-aem-ppv5-spa/components/common/staticwrapper': 'Static Wrapper',
  'mi-aem-ppv5-spa/components/content/internet-box': 'Internet Box',
  'mi-aem-ppv5-spa/components/content/accuWeather': 'Accu Weather Component',
  'mi-aem-ppv5-spa/components/content/brandedcontainer': 'Branded Container',
  'mi-aem-ppv5-spa/components/content/services-carousel': 'Service Cards Component',
  'mi-aem-ppv5-spa/components/content/lets-connect-modal': 'Lets Connect Modal',
  'mi-aem-ppv5-spa/components/content/ppv5-rte': 'PPv5 RTE',
  'mi-aem-offers-spa/components/offers-cards': 'Offers Cards Carousel',
  'mi-aem-homepage-spa/components/content/universal-footer': 'Universal Footer',
  'mi-aem-common-spa/components/content/mmn-container': 'MMN Container',
  'mi-aem-common-spa/components/content/bannerlayered': 'Offers Banner Layered',
  'mi-aem-common-spa/components/text': 'Text',
  'mi-aem-common-spa/components/title': 'Title',
  'mi-aem-common-spa/components/content/bannerlayered': 'Banner Layered',
  'mi-aem-common-spa/components/content/cardhorizontalmini': 'Card Horizontal Mini-Standard',
  'mi-aem-common-spa/components/content/cardlayered': 'Card Layered',
  'mi-aem-homepage-spa/components/content/global-navigation': 'Global Navigation',
  'mi-aem-homepage-spa/components/content/utilityNavigation': 'Utility Navigation',
  'mi-aem-homepage-spa/components/content/primaryNavigation': 'Primary Navigation',
  'mi-aem-common-spa/components/content/mangopilot': 'Mango Pilot',
  'mi-aem-common-spa/components/content/riottmediacard': 'Riott Media Card',
  'mi-aem-common-spa/components/content/tilesquare': 'Tile Square',
  'mi-aem-common-spa/components/content/tileskinny': 'Tile Skinny',
  'mi-aem-common-spa/components/content/tilecarouselcontainer': 'Tile Carousel Container',
  'mi-aem-common-spa/components/content/dcadecisioncontainer': 'DCA Decision Container',
  'mi-aem-common-spa/components/content/merchandisingsmallbanner': 'Merchandising Small Banner',
  'mi-aem-common-spa/components/content/modal': 'Modal',
  'nt:unstructured': 'Editable HTL Wrapper',
  'mcom-book-spa/components/flyoutcontainer': 'Flyout Container',
  'mi-aem-account/components/content/accountcontainer': 'Account Container',
  'mi-aem-account/components/content/signin': 'Sign In',
  'mi-aem-account/components/content/signincontentblock': 'Sign In Content Block',
  'mi-aem-account/components/content/datapagecomponent': 'Data Page Component',
};

export const getAllowedComponentsForNonAuthorMode = model => {
  return getAllowedComponentsForNonAuthorModeUtil(model, AEM_REACT_MAPPING, AEM_REACT_TITLE_MAPPING);
};

export const defineComponentMapping = (allowedComponents, isAuthorMode, pageProps, ppv5CarouselFeatureFlags) => {
  const logger = global.loggerInstance?.('defineComponentMapping');
  const log = logger?.log || (() => {});
  const logError = logger?.error || (() => {});

  try {
    const { carousel_switch_ppv5 = false } = ppv5CarouselFeatureFlags;
    const ppv5CarouselFromLightning =
      (pageProps?.query?.lightning === 'true' || carousel_switch_ppv5 === true) &&
      !pageProps?.requestUri?.includes('/preview');

    MapTo(`mi-aem-offers-spa/components/offers-cards`)(
      props => (
        // Rename to address broken homepage build caused by DXP-7950
        <OfferCardCarousel
          {...props}
          offersData={pageProps.productSpecificResponse ?? []}
          isAuthorMode={isAuthorMode}
          acceptLanguage={pageProps.headersData['accept-language']}
          requestId={pageProps?.requestId}
          cookie={pageProps?.headersData['cookie']}
          isLightning={ppv5CarouselFromLightning}
        />
      ),
      {
        emptyLabel: 'Offers Card Carousel',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-homepage-spa/components/content/universal-footer`)(
      props => <Footer {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'Footer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-common-spa/components/text`)(Text);
    MapTo(`mi-aem-common-spa/components/title`)(Heading);
    MapTo(`mi-aem-common-spa/components/content/cardlayered`)(CardLayered, {
      emptyLabel: 'CardLayered',
      isEmpty: false,
    });
    MapTo(`mi-aem-common-spa/components/common/staticwrapper`)(StaticWrapper, {
      emptyLabel: 'StaticWrapper',
      isEmpty: false,
    });

    MapTo(`mi-aem-ppv5-spa/components/content/localheader`)(
      props => <LocalHeaderEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'LocalHeader',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-ppv5-spa/components/content/hero-banner`)(
      props => <HeroBannerEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'HeroBanner',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-ppv5-spa/components/content/accuWeather`)(
      props => <AccuWeatherEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'AccuWeather',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-common-spa/components/content/dcadecisioncontainer`)(
      props => (
        <DCADecisionContainer
          {...props}
          isAuthorMode={isAuthorMode}
          allowedComponents={allowedComponents}
          resolvedUrl={pageProps?.resolvedUrl}
        />
      ),
      {
        emptyLabel: 'DCA Wrapper',
        isEmpty: false,
      }
    );

    MapTo('mi-aem-common-spa/components/content/tilesquare')(
      props => <MerchandisingCardTile {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'Tilesquare',
        isEmpty: false,
      }
    );

    MapTo('mi-aem-common-spa/components/content/tileskinny')(
      props => <MerchandisingTileSkinny {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'TileSkinny',
        isEmpty: false,
      }
    );

    MapTo('mi-aem-common-spa/components/content/tilecarouselcontainer')(
      props => <MerchandisingCarouselContainer {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'Tile Carousel Container',
        isEmpty: false,
      }
    );

    MapTo('mi-aem-common-spa/components/content/mangopilot')(props => {
      return <RiottMediaCard {...props} isAuthorMode={isAuthorMode} />;
    });

    MapTo('mi-aem-common-spa/components/content/riottmediacard')(props => {
      return <RiottMediaCard {...props} isAuthorMode={isAuthorMode} />;
    });

    MapTo(`mi-aem-common-spa/components/content/merchandisingsmallbanner`)(
      props => <MerchandisingSmallBanner {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'MerchandesingSmallBanner',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-common-spa/components/content/modal`)(
      props => <PropertyPortalWrapperEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'PropertyPortalWrapper',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-ppv5-spa/components/content/internet-box`)(
      props => <InternetBarEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'InternetBarComponent',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-ppv5-spa/components/content/ppv5-rte`)(
      props => <RTEEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'RTEComponent',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-ppv5-spa/components/common/staticwrapper`)(
      props => <ConnectContainerEditable {...props} isAuthorMode={isAuthorMode} readyToMount={false} />,
      {
        emptyLabel: 'ConnectContainer',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-ppv5-spa/components/content/brandedcontainer`)(
      props => (
        <PropertyPortalContainerEditable
          {...props}
          isAuthorMode={isAuthorMode}
          isLightning={ppv5CarouselFromLightning}
        />
      ),
      {
        emptyLabel: 'PropertyPortalContainer',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-common-spa/components/content/cardhorizontalmini`)(
      props => <BonvoyApplicationAdEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'BonvoyApplicationAdComponent',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-common-spa/components/content/bannerlayered`)(
      props => <JoinBannerExperienceEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'JoinBannerExperience',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-common-spa/components/content/mmn-container`)(
      props => <MMNComponentEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'MMNComponent',
        isEmpty: false,
      }
    );

    MapTo(`mi-aem-ppv5-spa/components/content/services-carousel`)(
      props => <LocalServicesEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'services_carousel',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-ppv5-spa/components/content/lets-connect-modal`)(
      props => <LetsConnectEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'letsConnect',
        isEmpty: false,
      }
    );

    const ExperienceFragmentVariationConfig = {
      emptyLabel: 'Experience Fragment',

      isEmpty: function (props) {
        return !props || !props.configured;
      },
    };

    MapTo(`mi-aem-ppv5-spa/components/content/experiencefragment`)(props => {
      return (
        <Container
          isInEditor
          {...props}
          isPage={false}
          model={respGridUtil(props?.model)}
          isLightning={ppv5CarouselFromLightning}
        />
      );
    }, ExperienceFragmentVariationConfig);

    MapTo(`mi-aem-homepage-spa/components/content/global-navigation`)(
      props => <NavigationContainerWrapper {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'NavigationContainerWrapper',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-homepage-spa/components/content/utilityNavigation`)(NavigationUtilityLinkWrapper);
    MapTo(`mi-aem-homepage-spa/components/content/primaryNavigation`)(NavigationWrapper);

    MapTo(`mcom-book-spa/components/flyoutcontainer`)(
      props => <FlyoutDrawer {...props.model} {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'FlyoutDrawer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-account/components/content/accountcontainer`)(
      props => <AccountContainerEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'accountcontainer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-account/components/content/signin`)(
      props => <SignInEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'signin',
      }
    );
    MapTo(`mi-aem-account/components/content/signincontentblock`)(
      props => <SignInContentBlockEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'signincontentblock',
      }
    );
    const DataPageVariationConfig = {
      emptyLabel: 'Data Page',
      isEmpty: function (props) {
        return !props || !props.configured;
      },
    };
    MapTo('mi-aem-account/components/content/datapagecomponent')(props => {
      const gridItems = props?.model?.cqItems?.responsivegrid?.[':items'];
      const isAccountContainer = gridItems ? Object.keys(gridItems)?.[0]?.includes('accountcontainer') : false;

      return (
        <Container
          isInEditor
          {...props}
          isPage={false}
          model={isAccountContainer ? respGridUtil(props?.model?.cqItems?.responsivegrid) : props?.model}
        />
      );
    }, DataPageVariationConfig);

    // Fallback for nt:unstructured (JCR type in responsive breakpoints, etc.) - only referenced in author mode
    MapTo(`nt:unstructured`)(EditableHTLWrapper, {
      emptyLabel: 'Unstructured',
      isEmpty: true,
    });

    const existingMappings = Object.keys(AEM_REACT_MAPPING);

    // Validate allowedComponents before processing
    if (allowedComponents && Array.isArray(allowedComponents)) {
      let successCount = 0;
      let failureCount = 0;

      allowedComponents.forEach((mapping, index) => {
        try {
          // Validate mapping object structure
          if (!mapping || typeof mapping !== 'object') {
            throw new Error(`Invalid mapping object at index ${index}`);
          }

          if (!mapping.path || typeof mapping.path !== 'string') {
            throw new Error(`Invalid or missing path in mapping at index ${index}`);
          }

          const baseModelPath = '/jcr:content/root/responsivegrid/';
          const componentPath = mapping.path.split(baseModelPath)[1];

          if (!componentPath) {
            throw new Error(`Unable to extract component path from: ${mapping.path}`);
          }

          if (existingMappings.indexOf(componentPath) === -1) {
            MapTo(componentPath)(EditableHTLWrapper, {
              emptyLabel: mapping.title || 'Component',
              isEmpty: false,
            });
            successCount++;
          } else {
            if (process.env.NODE_ENV === 'development') {
              log('Mapping already exists, skipping:', componentPath);
            }
          }
        } catch (mappingError) {
          failureCount++;
          if (process.env.NODE_ENV === 'development') {
            logError(`Failed to map component at index ${index}:`, {
              error: mappingError.message,
              mapping: mapping,
              stack: mappingError.stack,
            });
          }
          // Continue processing remaining components
        }
      });

      if (process.env.NODE_ENV === 'development') {
        log(
          `Component mapping complete. Success: ${successCount}, Failed: ${failureCount}, Total: ${allowedComponents.length}`
        );
      }
    } else if (process.env.NODE_ENV === 'development') {
      log('No allowed components provided or invalid format');
    }
  } catch (err) {
    // Always log errors regardless of environment - use your server logger, not console
    logError('Critical error in defineComponentMapping:', {
      error: err.message,
      stack: err.stack,
    });
    // Re-throw so the caller (page bootstrap) can decide recovery strategy.
    // Silent failure here means EVERY AEM component renders as blank with zero observability.
    throw err;
  }
};
